<template>
  <div>
      <tplheader></tplheader>
      <tplLeftPanel></tplLeftPanel>
    <form>
      <div id="fixed-top-menu-outer" class="fixed-top-menu-outer">
        <div class="fixed-top-menu">
          <div class="pull-right">
            <router-link v-if="$root.checkRule('card/edit/create')" class="btn btn-primary" :to="{ path: '/card/edit' }"><i class="fa fa-plus"></i>Új kártya</router-link>
            <ajaxLoaderButton v-if="cards.length > 0" :onClick="excelExport" iconclass="fa fa-file-excel-o" label="Excel export" v-model="is_excel_export"/>
          </div>
        </div>
      </div>
      <div id="main-panel" class="main-panel">
        <div class="content-panel">
          <ul class="breadcrumb">
            <li>Kezdőőoldal</li>
            <li>Kártyák</li>
          </ul>
          <div class="page-title">
            <h1><i class="material-icons">chevron_right</i>Kártyák</h1>
          </div>
          <div class="content-panel-top-btn-group">
            <router-link v-if="$root.checkRule('card/edit/create')" class="btn btn-primary" :to="{ path: '/card/edit' }"><i class="fa fa-plus"></i>Új kártya</router-link>
            <ajaxLoaderButton v-if="cards.length > 0" :onClick="excelExport" iconclass="fa fa-file-excel-o" label="Excel export" v-model="is_excel_export"/>
          </div>
          <div class="panel">
            <div class="panel-heading">
              <h4>Kártyák</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="panel-sub-heading"><h4>Kereső</h4></div>
                    </div>
                    <div class="col-xs-2">
                      <inputbox id="card_number" :keydownEnter="searchClick" label="Kártya szám / Név / Neptunkód" name="card_number" v-model="search.card_number"></inputbox>
                    </div>
                    <div class="col-xs-1">
                      <inputbox maxlength="8" inputCheck="cardRf" :keydownEnter="searchClick" id="rfid" label="RF ID" name="rfid" v-model="search.rfid"></inputbox>
                    </div>
                    <div class="col-xs-2">
                      <combobox id="status" label="Státusz" name="status" v-model="search.status"></combobox>
                    </div>
                    <div class="col-xs-2">
                      <combobox id="tipus" label="Típus" name="tipus" v-model="search.tipus"></combobox>
                    </div>
                    <div class="col-xs-1">
                      <inputbox datepicker="1" id="tol" label="dátum -tól" name="tol" v-model="search.tol"></inputbox>
                    </div>
                    <div class="col-xs-1">
                      <inputbox datepicker="1" id="ig" label="dátum -ig" name="ig" v-model="search.ig"></inputbox>
                    </div>
                    <div class="col-xs-3">
                      <div style="margin-top: 12px">
                        <button class="btn btn-white" type="button" v-on:click="searchClick"><i class="fa fa-search"></i>Keresés</button>
                        <ajaxLoaderButton class="btn-white" v-model="creating_zip" v-if="zipcards.length > 0 && $root.checkRule('card/edit/print')" :onClick="cardsToZIP" iconclass="fa fa-print" :label="'ZIP ('+zipcards.length+')'"/>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-1">
                      <inputbox inputCheck="integer" id="kartyaszam_tol" label="kártyaszám -tól" name="kartyaszam_tol" v-model="search.kartyaszam_tol"></inputbox>
                    </div>
                    <div class="col-xs-1">
                      <inputbox inputCheck="integer" id="kartyaszam_ig" label="kártyaszám -ig" name="kartyaszam_ig" v-model="search.kartyaszam_ig"></inputbox>
                    </div>
                    <div class="col-xs-2">
                      <combobox id="ujragyartott" label="Újragyártott" name="ujragyartott" v-model="search.ujragyartott"></combobox>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12">
                  <div v-if="cards.length">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Kártyaszám</th>
                        <th>RF ID</th>
                        <th>Kártyabirtokos</th>
                        <th>Létrehozva</th>
                        <th>Módosítva</th>
                        <th>Státusz</th>
                        <th>Újragyártott</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="card in cards">
                        <td>{{card.prefix}}{{card.card_number}}</td>
                        <td>{{card.rf_id}}</td>
                        <td>{{card.owner}}</td>
                        <td>{{card.created}}</td>
                        <td>{{card.last_modified}}</td>
                        <td>{{card.status}}</td>
                        <td>{{card.remanufactured}}</td>
                        <td>
                          <ul class="icon-list">
                            <li class="dropdown"><a class="dropdown-toggle" href="javascript:void(0)"><i class="fa fa-gear"></i></a>
                              <ul class="dropdown-menu">
                                <li class="dropdown-header">Opciók</li>
                                <li><router-link :to="{ path: '/card/edit/', query: { id: card.id }}"><i class="fa fa-pencil-square-o"></i>Szerkeszt</router-link></li>
                              </ul>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <pagination showcombo="1" :limit="query.limit" :amount="query.amount" v-on:pageChanged="pageChanged" v-model="query.page"></pagination>
                  </div>
                  <div v-else>
                    Nem található kártya.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>
<script>
import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {
      query: {
        card_number: '',
        status: 0,
        tipus: 0,
        rfid: '',
        page: 1,
        limit: 100,
        amount: 0,
        tol: '',
        ig: ''
      },
      search: {
        card_number: '',
        status: {
          items: [],
          selected: 0
        },
        tipus: {
          items: [],
          selected: 0
        },
        ujragyartott: {
          items: [
            {
              label: '- Összes -',
              value: 0
            },
            {
              label: 'Igen',
              value: 1
            },
            {
              label: 'Nem',
              value: 2
            }
          ],
          selected: 0
        },
        rfid: '',
        tol: '',
        ig: '',
        kartyaszam_tol: '',
        kartyaszam_ig: ''
      },
      cards: [],
      zipcards: [],
      creating_zip: false,
      is_excel_export: false
    }
  },
  watch: {
    '$route': 'routerChange'
  },
  methods: {
    excelExport: function() {
      var _this = this;
      this.is_excel_export = true;

      this.$root.ajax('card/excel_export', {
        data: this.query,
        method: 'POST',
        success: function(response) {
          _this.is_excel_export = false;

          if (response.filename != undefined) {
            window.open('excel_export/' + response.filename);
          } else {
            swal('Figyelem', 'Az exportálás során hiba történt: ' + response.error, 'error');
          }
        }
      });
    },

    clearSearchFields: function() {
      this.search.card_number = '';
      this.search.status.selected = 0;
      this.search.tipus.selected = 0;
      this.search.rfid = '';
      this.search.tol = '';
      this.search.ig = '';
      this.search.kartyaszam_tol = '';
      this.search.kartyaszam_ig = '';
      this.search.ujragyartott.selected = 0;
    },

    watchCardReader: function() {
      if (this.$root.socket.readyState === WebSocket.OPEN) {
        this.$root.socket.close();
      }

      var _this = this;
      try {
        this.$root.socket = new WebSocket("wss://kmr-reader.uninet.hu:8080");

        this.$root.socket.onmessage = function (event) {
          if (event.data != undefined) {
            _this.clearSearchFields();
            _this.search.rfid = event.data;
            _this.searchClick();
          }
        };
      } catch(err) {

      }
    },

    routerChange: function() {
      if (Object.keys(this.$route.query).length != 0) {
        this.query = JSON.parse(JSON.stringify(this.$route.query));
        this.search.card_number = this.query.card_number;
        this.search.status.selected = this.query.status;
        this.search.tipus.selected = this.query.tipus;
        this.search.rfid = this.query.rfid;
        this.search.tol = this.query.tol;
        this.search.ig = this.query.ig;
        this.search.kartyaszam_tol = this.query.kartyaszam_tol;
        this.search.kartyaszam_ig = this.query.kartyaszam_ig;
        this.search.ujragyartott.selected = this.query.ujragyartott;

      } else {
        this.query = {
          card_number: '',
          rfid: '',
          status: 0,
          tipus: 0,
          page: 1,
          limit: 100,
          amount: 0,
          tol: '',
          ig: '',
          kartyaszam_tol: '',
          kartyaszam_ig: '',
          ujragyartott: 0
        };
        this.search.card_number = '';
        this.search.rfid = '';
        this.search.status.selected = 0;
        this.search.tipus.selected = 0;
        this.search.ujragyartott.selected = 0;
      }

      this.getList();
    },

    pageChanged: function(val) {
      this.query.page = val;
      this.$router.push({path: '/card/list', query: this.query});
    },

    searchClick: function() {
      this.query.page = 1;
      this.query.card_number = this.search.card_number;
      this.query.status = this.search.status.selected;
      this.query.tipus = this.search.tipus.selected;
      this.query.rfid = this.search.rfid;
      this.query.tol = this.search.tol;
      this.query.ig = this.search.ig;
      this.query.kartyaszam_tol = this.search.kartyaszam_tol;
      this.query.kartyaszam_ig = this.search.kartyaszam_ig;
      this.query.ujragyartott = this.search.ujragyartott.selected;

      this.$router.push({path: '/card/list', query: this.query});
    },

    getList: function() {
      var _this = this;

      this.$root.ajax('card/list', {
        data: this.query,
        method: 'POST',
        success: function(response) {
          _this.cards = response.cards;
          _this.query.amount = response.amount;
          _this.search.status.items = response.statusCombo.items;
          _this.search.tipus.items = response.tipusCombo.items;

          _this.zipcards = [];
          _this.cards.map((card) => {
            if (card.status == 'Nyomtatásra vár') {
              _this.zipcards.push(card.id);
            }
          });
        }
      });
    },

    cardsToZIP() {
      const _this = this;

      swal({
        title: "Indulhat a nyomtatandó kártyák Zip állományba tömörítése?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Nem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.creating_zip = true;

          _this.$root.ajax('card/zip_print/', {
            method: 'POST',
            data: {
              zipcards: _this.zipcards
            },
            success: function(response) {
              _this.creating_zip = false;

              if (response.error != undefined) {
                swal('Hiba!', response.error, 'error');

              } else if (response.zipfile != undefined) {
                window.open(response.zipfile);
              }
            }
          });
        }
      });
    }
  },
  created: function() {
    this.routerChange();
    this.watchCardReader();
  },
  mounted: function() {

  }
}
</script>


// WEBPACK FOOTER //
// cards.vue?34c2bc5c